import { render, staticRenderFns } from "./selectColl.vue?vue&type=template&id=2b4d5e22&scoped=true&"
import script from "./selectColl.vue?vue&type=script&lang=js&"
export * from "./selectColl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d5e22",
  null
  
)

export default component.exports